import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { ToggleService } from '../../services/toggle.service';
import { CustomerService } from '../../services/customer.service';
import { UsersService } from '../../services/users.service';
import { CryptoService } from '../../services/crypto.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
})
export class AppMenuComponent implements OnInit {

  public role = "";
  public avAppPages = [
    {
      title: 'Dashboard',
      url: '/home',
      icon: 'home',
      role: 'au,ad'
    },
    {
      title: 'Projects',
      url: '/projects',
      icon: 'briefcase',
      role: 'au,ad'
    },
    {
      title: 'Outcomes',
      url: '/outcomes',
      icon: 'ribbon',
      role: 'au,ad'
    },
    {
      title: 'Media',
      url: '/media-management',
      icon: 'photos',
      role: 'au,ad,sa'
    },
    {
      title: 'Daily Report',
      url: '/daily-report',
      icon: 'analytics',
      role: 'ad'
    }, {
      title: 'Learners',
      url: '/learners',
      icon: 'person',
      role: 'au,ad'
    },
    {
      title: 'Admins & Authors',
      url: '/admins-authors',
      icon: 'people',
      role: 'ad'
    },
    {
      title: 'Customers',
      url: '/customers',
      icon: 'people',
      role: 'sa'
    },
    {
      title: 'My Account',
      url: '/my-account',
      icon: 'build',
      role: 'ad'
    },
    {
      title: 'My Orders',
      url: '/my-orders',
      icon: 'list-box',
      role: 'ad'
    },
    {
      title: 'My Profile',
      url: '/my-profile',
      icon: 'key',
      role: 'sa,ad,au'
    },
    {
      title: 'Help',
      url: '/help',
      icon: 'help-circle',
      role: 'sa,ad,au'
    }
  ];
  public appPages = []

  constructor(
    public toggleService: ToggleService,
    public authService: AuthenticationService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public customerService: CustomerService,
    public userService: UsersService,
    public cryptoService: CryptoService
  ) { 
  }

  ngOnInit() {
    //this.authService.check2FA();
    // if (this.authService.redirectTo2FA()) {
    //   this.router.navigateByUrl('/two-factor-authentication');
    // }

    setInterval(() => {
      this.role = this.cryptoService.decryptData(localStorage.getItem("login_r"));
      this.appPages = this.avAppPages.filter(x => x.role.indexOf(this.role) >= 0);
    }, 2000);
  }

  logOut() {
    this.authService.logOut();
  }

  myProfile() {
    this.userService.presentUpsertProfile(this.cryptoService.decryptData(localStorage.getItem("login_email")));
  }

}
